import React from 'react';
import { FaChevronLeft, FaChevronRight } from 'react-icons/fa';
import HtmlDecode from 'utils/htmlDecode';

const Controls = ({
  carouselKey,
  title,
  handleNextSlide,
  handlePrevSlide,
  showControls,
  prevArrowIcon,
  nextArrowIcon,
  prevIconClassName = '',
  nextIconClassName = '',
}) => {
  return (
    <div className="carousel-button-group">
      <div className="cv-generic-carousel-nav__header">
        {title && (
          <h2 className="cv-generic-carousel-nav__header__title">
            {HtmlDecode(title)}
          </h2>
        )}
        {showControls && (
          <div className="cv-generic-carousel-nav__header__navigation">
            {prevArrowIcon ? (
              <img
                className={`cv-generic-carousel-nav__header__navigation__prev-btn ${prevIconClassName} prev-btn-${carouselKey}`}
                src={prevArrowIcon}
                alt="back"
                onClick={() => handlePrevSlide()}
              />
            ) : (
              <FaChevronLeft
                className={`cv-generic-carousel-nav__header__navigation__prev-btn prev-btn-${carouselKey}`}
                onClick={() => handlePrevSlide()}
              />
            )}
            {nextArrowIcon ? (
              <img
                className={`cv-generic-carousel-nav__header__navigation__next-btn ${nextIconClassName} next-btn-${
                  carouselKey
                }`}
                src={nextArrowIcon}
                alt="next"
                onClick={() => handleNextSlide()}
              />
            ) : (
              <FaChevronRight
                className={`cv-generic-carousel-nav__header__navigation__next-btn next-btn-${carouselKey}`}
                onClick={() => handleNextSlide()}
              />
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default Controls;
